import * as actionTypes from './actionTypes'

export const searchRequested = (
  trackSearchCallBack?: (resultCount?: number) => void,
) => ({
  type: actionTypes.SEARCH_REQUESTED,
  payload: {
    trackSearchCallBack,
  },
})

export const searchAllStoresRequested = () => ({
  type: actionTypes.SEARCH_ALL_STORES_REQUESTED,
})

export const filtersUpdated = (filterIds: {
  [filterId: string]: boolean | string
}) => ({
  type: actionTypes.FILTERS_UPDATED,
  payload: filterIds,
})

export const filtersCleared = () => ({
  type: actionTypes.FILTERS_CLEARED,
})

export const detailsRequested = ({
  storeId,
}: {
  storeId: string | number
}) => ({
  type: actionTypes.DETAILS_REQUESTED,
  payload: { storeId },
})

export const loadMoreResults = () => ({
  type: actionTypes.LOAD_MORE_RESULTS,
})

export const searchTermUpdated = (
  searchTerm: string | undefined = undefined,
) => ({
  type: actionTypes.SEARCH_TERM_UPDATED,
  payload: { searchTerm },
})

export const searchTermCleared = () => ({
  type: actionTypes.SEARCH_TERM_CLEARED,
})

export const areaUpdated = (areaCode?: string) => ({
  type: actionTypes.AREA_UPDATED,
  payload: { areaCode: areaCode || null },
})

export const selectStore = (storeId?: number) => ({
  type: actionTypes.SELECTED_STORE_UPDATED,
  payload: { storeId },
})

export const selectMarker = (storeId?: number) => ({
  type: actionTypes.SELECTED_MARKER_UPDATED,
  payload: { storeId },
})

export const clearMarker = () => ({
  type: actionTypes.CLEAR_SELECTED_MARKER,
})

export const clearAll = (preserveAreaCode?: boolean) => ({
  type: actionTypes.CLEAR_ALL,
  payload: { preserveAreaCode },
})
